import React, {useState} from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import {CLIENT_DATE_FORMAT, SERVER_DATE_FORMAT} from '@app/const/AppSetting';
import moment from 'moment';

const NewDatePicker = (props) => {
    let val = ``;

    if (
        props.value &&
        props.value !== `` &&
        props.value !== undefined &&
        props.value !== `Invalid date`
    ) {
        let ddmmyyyy = parseDate_ddmmyyyy(props.value) ;
        if( ddmmyyyy === null )
        {
            try
            {
                if(!isValidDate_yyyyMMdd(props.value))
                {
                    val ='';
                }
                else
                {
                    val = new Date(props.value);
                    if(val === undefined || val === 'Invalid Date')
                        val = '';
                }
            }
            catch (Error)
            {
                val ='';
            }
        }
        else
        {
            val = ddmmyyyy;
        }
    }

    function  parseDate_ddmmyyyy(str) {
        var m = str.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
        return (m) ? new Date(m[3], m[2]-1, m[1]) : null;
    }

    function isValidDate_yyyyMMdd(str) {
        if(SERVER_DATE_FORMAT === 'yyyy-MM-DD')
        {
            return str.match(/^\d{4}-\d{2}-\d{2}$/);
        }
        return str.match(/^(\d{4})\/(\d{1,2})\/(\d{1,2})$/);
    }

    const handleonDayChange = (day) => {
        if (props.isV2) {
            let  val1 = moment(day).format(SERVER_DATE_FORMAT);
            if (
                day &&
                day !== `` &&
                day !== undefined &&
                day !== `Invalid date`
            ) {
                const target = {name: props.name, value: val1};
                props.onDayChange({target});
            } else {
                const target = {name: props.name, value: ``};
                props.onDayChange({target});
            }
        } else {
            const val1 = moment(day).format(SERVER_DATE_FORMAT);
            if (
                day &&
                day !== `` &&
                day !== undefined &&
                day !== `Invalid date`
            ) {
                props.onDayChange(val1);
            } else {
                props.onDayChange(``);
            }
        }
    };

    const dayPickerInputX = (
        <div className="react-datepicker-wrapper" style={{ width: '100%' }}>
            <DatePicker
                autoComplete="off"
                name={props.name}
                isClearable
                selected={val}
                onChange={handleonDayChange}
                className={`${props.className} w-100`}
                style={{ width: '100%' }}
                dateFormat={CLIENT_DATE_FORMAT}
                peekNextMonth
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
                wrapperClassName="w-100"
            />
        </div>
    );

    if(props.readOnly)
    {
        return (
            <input
                readOnly
                type="text"
                className={`form-control ${props.className || ''}`}
                autoComplete='off'
                style={{ width: '100%' }}
                value={ moment(val).format('DD/MM/YYYY') }
            />
        );
    }

    return dayPickerInputX;
};

export default NewDatePicker;